import { render, staticRenderFns } from "./PaydunyaMain.vue?vue&type=template&id=29ca491d"
import script from "./PaydunyaMain.vue?vue&type=script&lang=ts"
export * from "./PaydunyaMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports